import { useApi } from "../../../utils";
import {
  ContractRetainerSpend,
  ContractRetainerSpendClient,
} from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";

export const getContractRetainerSpendByContractId = (contractId?: number) => {
  const api = useApi(ContractRetainerSpendClient);

  const getRetainerSpendByContractId = async () => {
    return await api.getContractRetainerSpendByContractId(contractId);
  };

  return useQuery<ContractRetainerSpend, Error>({
    queryKey: [`contract-retainer-spend-contract-${contractId}`],
    queryFn: getRetainerSpendByContractId,
    enabled: contractId != null,
  });
};
